import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { barService } from 'src/app/core/services/common/bar.service';
import { Group } from 'src/app/core/models/bar.model';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    standalone: false
})
export class SidebarComponent implements OnInit{
  arr: Group[] = [];
  filteredArr: Group[] = [];
  selectedItem: any = null;
  currentRouteSub: string = '';

  constructor(private router: Router, private barService: barService) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.updateSelectedItem(event.urlAfterRedirects);
        this.currentRouteSub = event.urlAfterRedirects;
      }
    });
  }

  ngOnInit() {
    this.arr = this.barService.getBarData();
    this.updateSelectedItem(this.router.url);
  }

  updateSelectedItem(currentRoute: string) {
    this.selectedItem = null;
    const routeParts = currentRoute.split('/TCO/ProcessEng/')[1]?.split('/');
    if (!routeParts || routeParts.length < 3) {
      this.filteredArr = [];
      return;
    }

    const [firstPart, secondPart, thirdPart] = routeParts;

    const filterAndMap = (groupId: string, itemId: string, childId: string) => {
      return this.arr
        .filter(group => group.id === groupId)
        .map(group => ({
          ...group,
          items: group.items
            .filter(item => item.id === itemId)
            .map(item => ({
              ...item,
              childs: item.childs
                .filter(child => child.id === childId)
                .map(child => ({
                  ...child,
                  schilds: child.schilds.map(schild => ({
                    ...schild,
                    tchilds: schild.tchilds
                  }))
                }))
            }))
        }))
        .filter(group => group.items.length > 0);
    };

    /* EXCEPTION CASES
    /* Make Attention:
    /* If routing names is not matching with the sidebar names, we need to handle them manually
    */
    if (
      currentRoute === '/TCO/ProcessEng/FD/KTL/DailyReport' || 
      currentRoute === '/TCO/ProcessEng/FD/KTL/F205/KTL2' || 
      currentRoute === '/TCO/ProcessEng/FD/KTL/F205/KTL23') {
      this.filteredArr = filterAndMap('FD', 'FD-KTL', 'FD-KTL-DAILY-REPORT');
    } else if (currentRoute === '/TCO/ProcessEng/FD/KTLSGP/So2Emissions/ProjectedData'){
      this.filteredArr = filterAndMap('FD', 'SO2-EMISSIONS', 'SO2-EMISSIONS-INPUT');
    } else if (
      currentRoute === '/TCO/ProcessEng/FGD/IUS/Input/boilers-motohours-data' ||
      currentRoute === '/TCO/ProcessEng/FGD/IUS/Input/heaters-motohours-data' ||
      currentRoute === '/TCO/ProcessEng/FGD/IUS/Input/meters-data'
    ){
      this.filteredArr = filterAndMap('FGD', 'FGD-IUS', 'FGD-IUS-INPUT');
    } else if (
      currentRoute === '/TCO/ProcessEng/FGD/IUS/calculations/boilers-motohours-data' ||
      currentRoute === '/TCO/ProcessEng/FGD/IUS/calculations/heaters-motohours-data' 
    ){
      this.filteredArr = filterAndMap('FGD', 'FGD-IUS', 'FGD-IUS-CALCULATIONS');
    } else if ( currentRoute ===  '/TCO/ProcessEng/FGD/IUS/MonthlyReport/monthly-calc'){
      this.filteredArr = filterAndMap('FGD', 'FGD-IUS', 'FGD-IUS-MONTHLY-REPORT');
    } else {
      this.filteredArr = this.arr
        .filter(group => group.id === firstPart)
        .map(group => ({
          ...group,
          items: group.items
            .filter(item => item.name === secondPart)
            .map(item => ({
              ...item,
              childs: item.childs
                .filter(child => child.routeName === thirdPart)
                .map(child => ({
                  ...child,
                  schilds: child.schilds
                }))
            }))
        }))
        .filter(group => group.items.length > 0);
    }
  }

  isSubChildActive(childName: string): boolean {
    const currentRoute = this.router.url;
    if(currentRoute === '/TCO/ProcessEng/FD/KTL/F205/KTL23'){
      return currentRoute === `/TCO/ProcessEng/${childName}`;
    }
    else{
      return currentRoute.includes(childName);
    }
  }
}
